<div class="mt-[20%] text-center">
    <h1>401: Unauthorized</h1>
    <p>You do not have the correct access rights to visit this page.</p>
    <p>Please navigate to a different page.</p>
</div>